import {ParsedUserAlertEntity} from './ParsedUserAlertEntity.js'
import {UserAlertEntity} from './UserAlertEntity.js'

export class UserAlertEntityFactory {
  static userAlertEntity = ({
    activeEmail,
    activePush,
    alertId,
    alertName,
    frequencyNotification,
    notAvailableFilters,
    numOfFiltersSelected,
    filters
  }) =>
    new UserAlertEntity({
      activeEmail,
      activePush,
      alertId,
      alertName,
      frequencyNotification,
      notAvailableFilters,
      numOfFiltersSelected,
      filters
    })

  static parsedUserAlertEntity = ({activeEmail, activePush, activeRealtimeEmail, activeRealtimePush, filters}) =>
    new ParsedUserAlertEntity({
      activeEmail,
      activePush,
      activeRealtimeEmail,
      activeRealtimePush,
      filters
    })
}
